import React, { createContext, useContext, useState } from "react";

const ToastContext = createContext();

export function useToast() {
  return useContext(ToastContext);
}

export function ToastProvider(props) {
  
  const [toastObj, setToastObj] = useState({ msg: null, type: null });

  const value = {
    toastObj,
    setToastObj,
  };

  return (
    <ToastContext.Provider value={value}>
      {props.children}
    </ToastContext.Provider>
  );
}
